import { Component, ElementRef, Renderer2, inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { BlockYoutubeDeprecated } from "@hermes/api-model-editorial";

import { CHAPTERS_PARAGRAPH } from "../../core";

export const YOUTUBE_PREFIX = "https://www.youtube.com/embed/";
@Component({
    selector: "h-block-youtube",
    templateUrl: "./block-youtube.component.html",
    styleUrls: ["./block-youtube.component.scss"],
    standalone: false,
})
export class BlockYoutubeComponent {
    blockYoutube = inject<BlockYoutubeDeprecated>(CHAPTERS_PARAGRAPH);
    private sanitizer = inject(DomSanitizer);
    private element = inject(ElementRef);
    private renderer = inject(Renderer2);

    public iframeUrl: SafeResourceUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(
            `${YOUTUBE_PREFIX}${this.getYoutubeVideoIdFromUrl(
                this.blockYoutube.url,
            )}`,
        );

    /**
     * Return the youtube video id from url received
     * Youtube url examples tested : 
     * 
     http://www.youtube.com/watch?v=-wtIMTCHWuI'
    'http://www.youtube.com/v/-wtIMTCHWuI?version=3&autohide=1'
    'https://youtu.be/A2ttjhH4DPk'
    'http://www.youtube.com/oembed?url=http%3A//www.youtube.com/watch?v%3D-wtIMTCHWuI&format=json'
    'http://www.youtube.com/attribution_link?a=JdfC0C9V6ZI&u=%2Fwatch%3Fv%3DEhxJLojIE_o%26feature%3Dshare'
     */
    public getYoutubeVideoIdFromUrl(url: string): string {
        const array = url.split(
            /(vi\/|v%3D|v=|\/v\/|\/e\/|youtu\.be\/|\/embed\/)/,
        );
        return array[2] === undefined ? array[0] : array[2].split(/[^\w-]/i)[0];
    }

    public ngAfterViewInit(): void {
        const currentElement: HTMLElement =
            this.element.nativeElement.querySelector(".block-youtube");
        if (this.blockYoutube.whiteBackground) {
            this.renderer.addClass(
                currentElement.parentElement,
                "white-background",
            );
        }
    }
}
